<template>
    <el-dialog title="回收" :visible.sync="show" width="550px">
        <el-cascader class="filter-item" style="width: 350px" placeholder="选择分配经销商" filterable :show-all-levels="false"
            :options="dealerOptions" v-model="dealerCode"></el-cascader>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { CONSTANT_0 } from '../js/form-options'
export default {
    name: 'assign-dealer',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        dealerOptions: {
            type: Array,
            default: () => []
        },
        multipleSelection: {
            type: Array,
            default: () => []
        },
        isAllCheck: {
            type: Boolean,
            default: false
        },
        queryParams: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
            this.dealerCode = []
        },
        show(newVal) {
            this.$emit('update:visible', newVal);
        },
    },
    data() {
        return {
            show: false,
            dealerCode: []
        }
    },
    methods: {
        handleSubmit() {
            if (this.dealerCode.length === CONSTANT_0) {
                this.$message("请选择经销商");
                return;
            }
            let dealerCode = this.dealerCode[this.dealerCode.length - 1];
            const selectedData = this.multipleSelection.filter(n => n.itemCheck)
            const selectedIds = selectedData.map(n => n.id).join(",");
            const noSelectedData = this.multipleSelection.filter(n => !n.itemCheck)
            const noSelectedIds = noSelectedData.map(n => n.id).join(",");
            const params = {
                query: {
                    ...this.queryParams
                },
                isAll: this.isAllCheck,
                ids: this.isAllCheck ? "" : selectedIds,
                excludeIds: this.isAllCheck ? noSelectedIds : "",
                dealerCode
            }
            this.$httpAuth
                .post("/v1/backendClueRpc/assignDealer", params)
                .then((response) => {
                    const msg = `成功${response.data.success}条${response.data.failed ? `，失败${response.data.failed}条` : ''}${response.data.offline ? `。其中失败的${response.data.offline}条为线下线索，不允许回收` : ''}`
                    this.$message({
                        message: response.data.detail || msg,
                        type: "success",
                    });
                    this.$emit('clear-check-get-list');
                    this.show = false;
                })
                .catch(() => { });
        },
    }
}
</script>